export function upperFirst(text){
    return text[0].toUpperCase() + text.slice(1).toLowerCase();
}

export function orderBy(array,prop){
    let equalizables = { 'á':'a', 'é':'e', 'í':'i', 'ó':'o', 'ú':'u', 'ñ':'nz',' ':''}
    function replaceLatinCharacters(value){
      return value.toLowerCase().replace(
        new RegExp(
            Object.keys(equalizables).join('|'),'g'
          ), 
          (match)=>equalizables[match] 
        )
    }
    return array.sort((a,b)=>{
      return replaceLatinCharacters(a[prop]) > replaceLatinCharacters(b[prop]) ? 1 : -1
    })
 }